class Mentions {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}/mentions`;
    this.apiClient = apiClient;

  }

  async search(queryOptions) {

    const path = `${this.basePath}/search`;

    return this.apiClient.get(path, {}, {
      filterOptions: {
        searchText: queryOptions.searchText,
        types: queryOptions.types
      }, paginationOptions: {
        skip: 0,
        limit: queryOptions.limit
      }
    });

  }

}

export default Mentions;
